import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import $ from "jquery";
import React, { useEffect, useState } from 'react';
import { Badge, Button, Col, Container, Form, Row, Table } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import "../../../mcss/main.css";
import ActivityLog from '../../ActivityLog';
import * as Common from "../../Common";
import Dialog from '../../Dialog';
import DialogYesNo from '../../Dialog_Yes_No';
import LoginHeader from '../../Login_header';
import Menu from '../../Menu';
import * as Picklist from "../../Picklist";
import Tran_data_unlock_request from '../../Tran_data_unlock_request';
function TranModificationDsrDer() {
    const navigate = useNavigate();
    const sid = sessionStorage.getItem("sessionId");
    const [scrMode, setScrMode] = useState('');
    const [filtertransaction, setFiltertransaction] = useState('VT');
    const [pProductList, setPProductList] = useState([]);
    const [ppLocationValue, setPPLocationValue] = useState(0);
    const [tranAuditTrail, setTranAuditTrail] = useState([]);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");
    const [ppLocation, setPPLocation] = useState(null);
    const [userRight, setUserRight] = useState([]);

    const [hdrLocation, setHdrLocation] = useState("");
    const [ppSrnoFrom, setPPSrnoFrom] = useState("");
    const [ppSrnoTo, setPPSrnoTo] = useState("");
    const [editbtnView, setEditbtnView] = useState(true);
    const [isSaveDialogOpen, setSaveDialogOpen] = useState(false);
    const [saveMsgTextYN, setSaveMsgTextYN] = useState("Are you sure you want to save?");
    const [showActivityLog, setShowActivityLog] = useState(false);
    const [logObject, setLogObject] = useState({ trantype: "", trannumber: "", trancategory: "" });
    const [compareData, setCompareData] = useState([]);
    const [editableObj, setEditableObj] = useState([]);
    const [editableLineNo, setEditableLineNo] = useState(0)
    const [editableIndex, setEditableIndex] = useState(100000)
    const [showEditRequest, setShowEditRequest] = useState(false);
    const [editLogObject, setEditLogObject] = useState({ trantype: "", trannumber: "", trancategory: "", tranDate: "" });
    const [unlockRequestType, setUnlockRequestType] = useState("");



    useEffect(() => {
        Common.getActiveBranch().then(response => {
            setPPLocation(response);
            response != null && handleLocationChange(response);
        });

        Common.callApi(Common.apiRight, [sid, 'all', 'TRANSACTION_MODIFICATION_DSR_DER'], function (result) {
            let resp = JSON.parse(result);
            if (resp.query === "1") {
                setUserRight(resp);
            } else {
                navigate('/'); // no query right
            }
        });
        const sessionValues = sessionStorage.getItem('values');
        if (sessionValues) {
            const sessionData = JSON.parse(sessionValues);
            if (sessionData.md_type == "PURCHASE") {
                setScrMode('A');
                // setNServiceType('R');
                Common.callApi(Common.apiIndividualProfile, [sid, 'getIndividualData', sessionData.code], (result) => {
                    let resp = JSON.parse(result);
                });
                sessionStorage.removeItem('values');
            } else {
                setScrMode('');
            }
        }
    }, []);
    const handleLocationChange = (value) => {
        setPPLocation(value);
        var id = value.id;
        var location = id.split("^");
        setPPLocationValue(location[1]);
        setHdrLocation(location[2]);
        sessionStorage.activeBranch = location[1];
    }

    const applyFilter = () => {
        $(".loader").show();
        var msg = [], i = 0;
        if (ppSrnoFrom === "") {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (ppSrnoFrom === "" ? "Srno" : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            var obj = {
                location: ppLocationValue,
                transaction: filtertransaction,
                srnofrom: ppSrnoFrom,
                srnoto: ppSrnoTo
            }
            Common.callApi(Common.apiModiDsrDer, [sid, "trandetailview", JSON.stringify(obj)], function (result) {
                $(".loader").hide();
                let resp = JSON.parse(result || null);
                setPProductList(resp?.trandetailproduct);
                setEditableObj(resp?.trandetailproduct)
            })
        }

    }

    const saveCommission = () => {
        var msg = [], i = 0;
        if (!editableObj[editableIndex].prd_rate) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (!editableObj[editableIndex]?.prd_rate ? "Rate. " : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            const obj = {
                ...editableObj[editableIndex],
                location: ppLocationValue,
                transaction: filtertransaction,
                srnofrom: ppSrnoFrom,
                srnoto: ppSrnoTo
            }
            $(".loader").show();
            setSaveDialogOpen(false);
            const infoObject = Common.compareArrays([compareData], [editableObj[editableIndex]]);
            setTranAuditTrail(Common.addInfoToAuditTrail(tranAuditTrail, infoObject, editableObj[editableIndex]?.prd_type, ppLocationValue));
            Common.callApi(Common.apiModiDsrDer, [sid, "updatecommission", JSON.stringify(obj), JSON.stringify(tranAuditTrail)], function (result) {
                let resp = JSON.parse(result || null);
                setPProductList(resp?.trandetailproduct);
                $(".loader").hide();
                setMsgText("Success");
                setMsgBox(true);
                setEditbtnView(true);
                setTranAuditTrail([]);
                // setEditableObj([]);
                setEditableLineNo(0);
                setEditableIndex(10000)
                expireUnlock();
            });
        }
    };

    const handleEditRequest = (index, item) => {
        const currDate = new Date();
        // const newDate = item?.prd_date?.split('-');//viewDate=2026-04-08
        // const newViewDate = newDate[2] + '-' + newDate[1] + '-' + newDate[0]
         const newViewDate =item?.prd_date;
        const newCurrDate = Common.dateYMD(currDate);
        const dateA = new Date(newViewDate);
        const dateB = new Date(newCurrDate);
        // Calculate the difference in milliseconds
        const differenceInMilliseconds = dateB - dateA;
        // Convert milliseconds difference to days
        const differenceInDays = Math.ceil(differenceInMilliseconds / (1000 * 3600 * 24));
        console.log(differenceInDays);
        const obj = {
            srno: ppSrnoFrom,
            type: filtertransaction,
            pageright: 'TRANSACTION_MODIFICATION_DSR_DER',
            location: ppLocationValue
        }
        Common.callApi(Common.apiUnlockEdit, [sid, 'checkUnlock', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setUnlockRequestType(resp.requestsrc);
            if (Common.editDateLimit == differenceInDays || resp.msg == "unlock") {
                handleEditRequest1(index, item);
            } else {
                setShowEditRequest(true);
                setEditLogObject({ trantype: filtertransaction, trannumber: ppSrnoFrom, location: ppLocationValue, tranDate: Common.dateYMD(currDate) });
            }
        })
    }

    const expireUnlock = () => {
        if ((scrMode == '' && unlockRequestType !== "SELF")) {
            const obj = {
                srno: ppSrnoFrom,
                type: filtertransaction,
                status: 'E',
                currentDate: Common.dateYMD(new Date()),
                pageright: 'TRANSACTION_MODIFICATION_DSR_DER'
            }
            Common.callApi(Common.apiUnlockEdit, [sid, 'expireUnlock', JSON.stringify(obj)], (result) => {
                console.log(result);
            });
        }
    }

    const handleEditRequest1 = (index, item) => {
        //check unlock is given or not
        setEditbtnView(false);
        setCompareData(item);
        console.log(item.prd_line_no);
        setEditableLineNo(item.prd_line_no);
        setEditableIndex(index)
    };

    const confirmRate = (item) => {
        setSaveDialogOpen(true);
    }
    const btnActivityLog = (item) => {
        setShowActivityLog(true);
        setLogObject({ trantype: item.prd_type, trannumber: item.prd_srno, trancategory: "T", location: item.prd_location, subtranno: item.prd_line_no });
    }

    const handleRateChange = (v, index) => {
        setEditableObj((prevObj) => {
            const updated = [...prevObj];
            updated[index] = { ...updated[index], prd_rate: v };
            return updated;
        });
    };


    return (

        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h3>Transaction Modification Dsr/Der</h3>
                    </Col>
                </Row>
                {scrMode === '' ?
                    <Row>
                        <Row>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>Location<span className="colorThemeRed">*</span></Form.Label>
                                    <AsyncSelect
                                        cacheOptions={false}
                                        defaultOptions={false}
                                        value={ppLocation}
                                        getOptionLabel={e => e.label + ' '}
                                        getOptionValue={e => e.id}
                                        loadOptions={Picklist.fetchLocationAllowedPicklist}
                                        onInputChange={Picklist.handleInputChange}
                                        onChange={handleLocationChange}
                                    // isDisabled={branchDisable === "true"}
                                    >
                                    </AsyncSelect>
                                </Form.Group>
                            </Col>
                            <Col className="col-md-3 col-6">
                                <Form.Label>Transaction</Form.Label>
                                <Form.Select
                                    value={filtertransaction}
                                    onChange={(e) => { setFiltertransaction(e.target.value); }}>
                                    <option value="VT">VT</option>
                                    <option value="VR">VR</option>
                                </Form.Select>
                            </Col>
                        </Row>
                        <Row>

                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>SrNo<span className="colorThemeRed">*</span></Form.Label>
                                    <Form.Control type='text' maxLength={10} value={ppSrnoFrom} onChange={e => Common.validateNumValue(e.target.value, setPPSrnoFrom)} />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>&nbsp;</Row>

                        <Row>
                            <Col >
                                <Button style={{ marginRight: '10px' }} variant="outline-primary" className="buttonStyle" size="sm" onClick={applyFilter}> List</Button>
                            </Col>
                            <Col></Col>
                        </Row>
                        <Row>&nbsp;</Row>
                        <Row>
                            <Table responsive bordered striped>
                                <thead>
                                    <tr>
                                        <th>Product</th>
                                        <th>Isd Code</th>
                                        <th>Isd Name</th>
                                        <th>Denomination</th>
                                        <th>Quantity</th>
                                        <th>Rate</th>
                                        <th>Amount</th>
                                        <th>USD Rate</th>
                                        <th>USD Amount</th>
                                        <th>Prefix</th>
                                        <th>From</th>
                                        <th>To</th>
                                        <th>&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {pProductList.map((item, index) => (
                                        <React.Fragment key={index}>
                                            {/* Product Row */}
                                            <tr>
                                                <td>{item.prd_product}</td>
                                                <td>{item.prd_isd}</td>
                                                <td>{item.isd_name}</td>
                                                <td>{item.prd_deno}</td>
                                                <td>{item.prd_qty}</td>
                                                <td>{item.prd_rate}</td>
                                                <td>{item.prd_amount}</td>
                                                <td>{item.prd_usd_rate}</td>
                                                <td>{item.prd_usd_amount}</td>
                                                <td>{item.prd_prefix}</td>
                                                <td>{item.prd_from}</td>
                                                <td>{item.prd_to}</td>
                                                <td></td>
                                            </tr>

                                            {/* Commission Row with Editable Fields */}
                                            <tr>
                                                <td colSpan="13">
                                                    <table style={{ width: '100%' }}>
                                                        <thead>
                                                            <tr>
                                                                <th>Rate</th>
                                                                <th>&nbsp;</th>
                                                                <th>&nbsp;</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                {/* {editbtnView && (editableLineNo != item.prd_line_no) }
                                                                {editbtnView +' '+ editableLineNo +' '+ item.prd_line_no} */}
                                                                <td >
                                                                    <Form.Control
                                                                        type='text'
                                                                        maxLength={10}
                                                                        disabled={editableLineNo !== item.prd_line_no}
                                                                        value={editableObj[index]?.prd_rate}
                                                                        onChange={(e) => handleRateChange(e.target.value, index)}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <span>
                                                                        <Badge bg="secondary" className="handCursor" onClick={() => btnActivityLog(item)}>Activity Log</Badge>
                                                                    </span>
                                                                </td>
                                                                <td >
                                                                    {(userRight.edit === "1" && !editbtnView) ?
                                                                        <Button style={{ marginRight: '10px' }} variant="outline-primary" className="buttonStyle" size="sm" onClick={() => confirmRate(item)}>Save</Button>
                                                                        : null}&nbsp;
                                                                    {(userRight.edit === "1" && editbtnView) ?
                                                                        <Button style={{ marginRight: '10px' }} variant="outline-primary" className="buttonStyle" size="sm" onClick={() => handleEditRequest(index, item)}>Edit</Button>

                                                                        : null} &nbsp;
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ))}
                                </tbody>
                                <Row>&nbsp;</Row>
                                <Row>&nbsp;</Row>
                            </Table>
                        </Row>
                        <Row>&nbsp;</Row>
                    </Row> : null}
            </Container>
            <ActivityLog logObject={logObject} show={showActivityLog} onHide={() => setShowActivityLog(false)} />
            <Tran_data_unlock_request logObject={editLogObject} show={showEditRequest} onHide={() => setShowEditRequest(false)} />
            <DialogYesNo isOpen={isSaveDialogOpen} onYes={(e) => saveCommission(editableObj[editableIndex])} onNo={(e) => setSaveDialogOpen(false)}>
                {saveMsgTextYN}
            </DialogYesNo>
            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>

        </>
    )
}

export default TranModificationDsrDer;

